import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';

export const appRoutes: Routes = [
  {path: '', redirectTo: '/files', pathMatch: 'full'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

}
